<template>
  <div class="top">
    <div style="float:left">
      <slot></slot>
    </div>
    <!-- v-show="isWindowSize('md')?expanted:!expanted" -->
    <div
      class="menu"
      style="float:right"
    >
      <el-button
        xclick="$router.push({name: 'timologiera'});"
        type="text"
        style="background-color:#095b69;"
        class="menu-item"
        v-if="access.invoices"
      >
        <a href="/dashboard.html#/timologiera">
          <i class="material-icons">receipt</i>
          <span v-if="!isWindowSize('md')">Παραστατικά</span>
        </a>
      </el-button>

      <el-button
        v-if="access.income"
        style="background-color:#017369;"
        type="text"
        class="menu-item"
        xclick="$router.push({name: 'incontact',params:{id:'all'}});"
      >
        <a href="/dashboard.html#/transactions/in/contact/all">
          <i class="material-icons">archive</i>
          <span v-if="!isWindowSize('md')">Εσοδα</span>
        </a>
      </el-button>
      <!-- <el-button type="text" class="menu-item">
        <a href="/vy-businesss.html">πελάτες</a>#505029
      </el-button>-->
      <el-button
        v-if="access.expensses"
        style="background-color:#7e331d;"
        type="text"
        class="menu-item"
        xclick="$router.push({name: 'outcontact',params:{id:'all'}});"
      >
        <a href="/dashboard.html#/transactions/out/contact/all">
          <i class="material-icons">unarchive</i>
          <span v-if="!isWindowSize('md')">Εξοδα</span>
        </a>
      </el-button>
      <!-- <el-button type="text" class="menu-item">
        <a href="/vy-sappliers.html">*προμηθευτές</a>
      </el-button>-->

      <el-button type="primary"  class="menu-item" v-if="access.partners">
        <a href="/partner-handling.html">
          <i class="material-icons">person_pin</i>
          <span v-if="!isWindowSize('md')">Εταιροι</span>
        </a>
      </el-button>

      <!-- <div
        v-for="(link,idx ) in links"
        :key="idx"
        v-if="link.isInvoiceHandler"
        class="menu-item dropdown"
      >
        <a @click="submenuOpen = !submenuOpen">παραστατικά</a>
        <div class="dropdown_menu" v-show="submenuOpen">
          <div v-for="(gr,invgr ) in invoiceGroups" :key="invgr" class="submenu-item">
            <a :href="link.url+'&timo_group='+invgr" @click="submenuOpen = false">ΣΕΙΡΑ:{{invgr}}</a>
          </div>
        </div>
      </div>
      <div v-else class="menu-item">
        <a :href="link.url">{{link.label}}</a>
      </div>-->
    </div>

    <div
      class="business_logo"
      @click="$router.push({name: 'dashboard'});"
      v-if="!isWindowSize('md')"
    >
      <img :src="logo" />
    </div>
    <!-- <div class="menu_btn" style="float:right" v-show="isWindowSize('md')">
      <span @click="expanted = !expanted" class="fa fa-fw fa-bars"></span>
    </div>-->
    <!-- <div class="menu">
    <div v-for="(link,idx ) in links" :key="idx">
      <div v-if="link.isInvoiceHandler" class="dropdown">
        <div v-for="(gr,invgr ) in invoiceGroups" :key="invgr">
          <a :href="link.url+'&timo_group='+invgr">ΣΕΙΡΑ:{{invgr}}</a>
        </div>
      </div>
      <div v-else class="menu-item">
        <a :href="link.url">{{link.label}}</a>
      </div>
    </div>

    <slot></slot>
    <img :src="logo"/>-->
  </div>
</template>

<script>
export default {
  name: "r-menu",
  props: {
    logo: {
      type: String,
      default: null
    },
    invoiceGroups: {
      type: Array,
      default: function() {
        return [{ Α: "Α" }];
      }
    },
    // expanted: { type: Boolean, default: false },
    ilinks: {
      type: Array,
      default: function() {
        return null;
      }
    }
  },
  computed: {
    access() {
      if (Receipt.team == "kriton" || Receipt.team == "pytheas")
        return {
          invoices: true,
          income: true,
          expensses: true,
          partners: false
        };
      if (Receipt.team == "iassis")
        return {
          invoices: false,
          income: true,
          expensses: true,
          partners: false
        };
      return { invoices: true, income: true, expensses: true, partners: true };
    }
  },
  data() {
    return {
      submenuOpen: false,
      expanted: false,
      links: [
        {
          url: "/invoices/?sira=invoice",
          label: "Τιμολογια",
          isInvoiceHandler: true
        },
        { url: "/vy-businesss.html", label: "Πελατες" },
        { url: "/vy-sappliers.html", label: "Προμηθευτες" },
        {
          url: "/invoices/?sira=receipt",
          label: "ΑΠΥ"
        }
      ]
    };
  }
};
</script>

<style>
.top {
  display: flex;
  position: relative;
  background: #009688;
  height: 43px;
  box-shadow: 0px 2px 4px #04424c;
  overflow: hidden;
}
.menu {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  background: #009688;
}
.menu-item {
  color: #ffffff;
  padding: 0rem 1rem 0rem 1rem;
  font-size: 18px;
  display: flex;

  align-items: center;

  cursor: pointer;
}
.menu-item:hover {
  /* box-shadow: 0px 0px 3px white; */
  text-decoration: none;
  background: #07a596;
  color: #ffffff;
}
.dropdown_menu {
  position: absolute;
  z-index: 1;
  background: #353a40;
}
.menu-item a {
  padding: 0.5rem 1.5rem 0.5rem 1.5rem;
  display: flex;

  align-items: center;
}
.business_logo img {
  height: 25px;
  margin: 15px 15px 0px 15px;
  cursor: pointer;
}
.menu_btn .fa {
  font-size: 24px;
  padding: 8px 10px 8px 10px;
  color: #ffffff;
}
/* @media screen and (max-width: 1200px) {
  .menu {
    flex-direction: column;
    order: 3;
    z-index: 1;
    position: absolute;
    left: 50px;
  }
} */
</style>
